import Alpine from "../alpine.js"

Alpine.data("workoutExerciseForm", () => ({
  submit () {
    this.$nextTick(() => {
      this.$refs.submitButton.click()
    })
  }
}))
